import { useState } from "react";
import { PageLayout } from "@/components/PageLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CalculatorSuperCalcCTA } from "@/components/CalculatorSuperCalcCTA";
import { calculatorCTAs } from "@/data/calculatorCTAs";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function SalesTaxCalculator() {
  const [price, setPrice] = useState("");
  const [taxRate, setTaxRate] = useState("10");
  const [mode, setMode] = useState("add");
  const [results, setResults] = useState<any>(null);

  const calculate = () => {
    const p = parseFloat(price);
    const rate = parseFloat(taxRate);
    
    if (!p || !rate || p <= 0) return;
    
    let taxAmount, totalPrice, priceBeforeTax;
    
    if (mode === "add") {
      taxAmount = p * (rate / 100);
      totalPrice = p + taxAmount;
      priceBeforeTax = p;
    } else {
      priceBeforeTax = p / (1 + rate / 100);
      taxAmount = p - priceBeforeTax;
      totalPrice = p;
    }
    
    setResults({
      priceBeforeTax: priceBeforeTax.toFixed(2),
      taxAmount: taxAmount.toFixed(2),
      totalPrice: totalPrice.toFixed(2)
    });
  };

  return (
    <PageLayout calculatorName="Sales Tax Calculator" calculatorPath="/calculator/sales-tax">
      <div className="grid gap-8 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>Calculate Sales Tax</CardTitle>
            <CardDescription>Add or remove tax from price</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label>Mode</Label>
              <Select value={mode} onValueChange={setMode}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="add">Add Tax to Price</SelectItem>
                  <SelectItem value="remove">Remove Tax from Price</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label>{mode === "add" ? "Price Before Tax ($)" : "Price with Tax ($)"}</Label>
              <Input type="number" value={price} onChange={(e) => setPrice(e.target.value)} placeholder="100.00" step="0.01" />
            </div>
            <div>
              <Label>Tax Rate (%)</Label>
              <Input type="number" value={taxRate} onChange={(e) => setTaxRate(e.target.value)} placeholder="10" />
            </div>
            <Button onClick={calculate} className="w-full">Calculate</Button>
          </CardContent>
        </Card>

        {results && (
          <>
            <Card>
              <CardHeader>
                <CardTitle>Results</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="flex justify-between text-lg">
                  <span>Price Before Tax:</span>
                  <span className="font-semibold">${results.priceBeforeTax}</span>
                </div>
                <div className="flex justify-between text-lg">
                  <span>Tax Amount ({taxRate}%):</span>
                  <span className="font-semibold text-red-500">+${results.taxAmount}</span>
                </div>
                <div className="flex justify-between text-xl border-t pt-4">
                  <span className="font-bold">Total Price:</span>
                  <span className="font-bold text-primary">${results.totalPrice}</span>
                </div>
              </CardContent>
            </Card>
            
            <CalculatorSuperCalcCTA config={calculatorCTAs["sales-tax"]} trigger={results.totalPrice} />
          </>
        )}
      </div>
    </PageLayout>
  );
}
